import dayjs from 'dayjs'
/**
 * Takes a moment object and then finds the utc offset and returns the value in minutes
 * @param {Date} momentObject
 */
const getOffsetTime = (timeStamp) => {
    if(dayjs.isDayjs(timeStamp)){
    

    return dayjs().utcOffset()*-1;

    } else {
        throw('Expected dayjs object')
    }

    
}

export default getOffsetTime;
